import { rest } from 'msw'

const getAccountApprovalsPreference = rest.get<{}>(
  `${API_URL}/api/approval/v3/preferences/all-preference-status`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(true))
  }
)

export const updateAccountApprovalsPreference = rest.put<{}>(
  `${API_URL}/api/approval/v3/preferences`,
  async (req, res, ctx) => {
    return res(ctx.json(200))
  }
)

export default [getAccountApprovalsPreference, updateAccountApprovalsPreference]
